import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin("homecareprovider", api.homecareproviders)({});
